import { gql } from '@apollo/client';
import list from './List';
import create from './Create';
import show from './Show';

export default {
  name: 'PositionSpecialties',
  inputShow: gql`
    query positionSpecialties($input: PositionSpecialtyQueryInput) {
      positionSpecialties(input: $input) {
        id
        __typename
      }
    }
  `,
  list,
  show,
  create,
  options: {
    group: 'Misc',
    label: 'Position Specialties',
  },
};
